module.exports = __webpack_public_path__ + "img/36.021c05a6.jpg";